const time = {
    syncInterval: 1000,
    syncSteps: 3,
}

export default { time, }
